// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"88e36546","159":"67593719","331":"e4c1c526","589":"d661d4d5"}[chunkId] + ".chunk.js";
};